// extracted by mini-css-extract-plugin
export default {"top-title-box":"EmotionWriteList_top-title-box__DXMXt","emotion-write-box":"EmotionWriteList_emotion-write-box__xB7s5"};